import React from 'react';
import { ProviderMatchProviderV9 } from '@kyruus/types';
import { useIntl } from '@kyruus/intl';
import {
  AboutContentContainer,
  AboutContentTitle,
  ClinicalSpecialInterestsList
} from '../styles';
import messages from '../../../lib/messages';

/* 
A special case for About section content
clinical_special_interests is an array of clinical keyword strings that are marked as a "special interest" in Connect
This is different than the field `clinical_interests` which is a custom xp rich text field
Other array fields in the About section are rendered as a string separated by line breaks
*/

export const ClinicalSpecialInterests = ({
  provider
}: {
  provider: ProviderMatchProviderV9;
}): React.ReactElement | null => {
  const intl = useIntl();
  const clinicalSpecialInterests = provider.clinical_special_interests ?? [];
  if (!clinicalSpecialInterests?.length) {
    return null;
  }
  const title = intl.formatMessage(
    messages.profileAbout_clinical_special_interests
  );
  return (
    <AboutContentContainer
      itemScope={true}
      itemType="https://schema.org/PropertyValue"
      itemProp="additionalProperty"
      data-testid="profile-about-clinical_special_interests"
    >
      <AboutContentTitle itemProp="name">{title}</AboutContentTitle>
      <ClinicalSpecialInterestsList itemProp="description">
        {clinicalSpecialInterests.map((interest) => (
          <li key={interest}>{interest}</li>
        ))}
      </ClinicalSpecialInterestsList>
    </AboutContentContainer>
  );
};
